export class RoamingCommunityMemberModel {
  nsId: string = "";
  communityId: string = "";

  constructor(nsId: string = "", communityId: string = "") {
    this.nsId = nsId;
    this.communityId = communityId;
  }
}
